import { gql, useQuery } from '@apollo/client'

export const SEARCH_ACCOUNT_MACHINES = gql`
  query SearchAccountMachines($value: String, $organizationId: String) {
    searchAccountMachines(value: $value, organizationId: $organizationId) {
      id
      name
      serialNumber
      description
      owned
      machine {
        make
        model
        year
      }
    }
  }
`

interface Data {
  searchAccountMachines: {
    id: string
    name: string
    serialNumber: string
    description: string
    owned: boolean
    machine: {
      make: string
      model: string
      year: number
    }
  }[]
}

const useAllAccountMachines = (organizationId) => {
  const { loading, data } = useQuery<Data>(SEARCH_ACCOUNT_MACHINES, {
    variables: { organizationId, value: '' },
    fetchPolicy: 'no-cache',
  })

  if (loading || !data) return []

  return data?.searchAccountMachines || []
}

export default useAllAccountMachines
